<div class="reduce-risk-container text-center">
	<h2 class="mb-5 reduce-risk-header">How Bad is It?</h2>
	<div class="row">
		<div class="col-xl-4 col-lg-12 mb-5">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<img src="../../assets/img/mckinsey-company.svg" alt="" />
				<p class="mt-4" style="font-size: larger">
					Corporations spend thousands (sometimes millions) of dollars
					in regulatory fines every year—and those numbers continue to
					rise.
				</p>
			</div>
		</div>
		<div class="col-xl-4 col-lg-12 mb-5">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#f3931f 0%,
						#ef5a23 50%,
						#9e0e5d 100%
					);
				"
			>
				<img src="../../assets/img/gartner.svg" alt="" />
				<p class="mt-4" style="font-size: larger">
					It’s time to Shift Left Compliance. That means you start
					compliant and stay compliant to help your company regain
					control and minimize risks like audit fines and reputation
					loss. According to the Gartner survey, organizations that
					began to automate their compliance reduced external audit
					costs by 27%.
				</p>
			</div>
		</div>
		<div class="col-xl-4 col-lg-12">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#1a70ad 0%,
						#2d318d 100%
					);
				"
			>
				<img src="../../assets/img/gartner.svg" alt="" />
				<p class="mt-4" style="font-size: larger">
					62% of Organizations Expect External Audit Fees to Increase
					(Gartner, 2021)
				</p>
			</div>
		</div>
	</div>
	<a href="https://go.regscale.com/RegScale-Create-Account">
		<button class="free-trial-btn px-3 py-2 mt-5">
			Start Your Free Trial Today
		</button></a
	>

	<div class="container reduce-risk-bottom">
		<img
			class="reduce-risk-image"
			src="../../assets/img/reduce-risk.png"
			alt=""
		/>
		<h2 class="mb-5 reduce-risk-header">
			Reduce risk. Improve agility. Lower costs.
		</h2>
		<p class="reduce-risk-content">
			Is your organization struggling to keep up with volatile
			regulatory <br class="d-none d-sm-block" />
			requirements? Reduce this burden and maintain real-time compliance
			that’s <br class="d-none d-sm-block" />
			continuous and complete with RegScale. <br /><br />
			We provide software created by experts in compliance and Regulatory
			<br class="d-none d-sm-block" />
			Operations <strong style="color: #f3931f">(RegOps)</strong>. Our
			goal is to help your organization mitigate risk and
			<br class="d-none d-sm-block" />
			regain control by automating compliance from the start.
		</p>
		<a href="https://go.regscale.com/RegScale-Create-Account">
			<button class="free-trial-btn px-3 py-2 mt-5">
				Get Started Today
			</button>
		</a>
	</div>
</div>
